import { Type } from '@angular/core';
import { LabelData } from 'src/app/models/print-labels/label-data';
import { PrintLabelBackgroundComponent } from 'src/app/modules/print-cards/components/print-labels/backgrounds/print-label-background.component';
import { PrintLabelContentComponent } from 'src/app/modules/print-cards/components/print-labels/label-content/print-label-content.component';
import { TwoByFourLabelStack } from './two-by-four-label-stack';
import { BrandInventoryLabelStackContentComponent } from '../../../../../modules/print-cards/components/print-labels/label-content/custom-labels-2x4/brand-inventory-label-stack-content/brand-inventory-label-stack-content.component';

export class BrandInventoryLabelStack extends TwoByFourLabelStack {
  getCardBackgroundComponent(labelData: LabelData): Type<PrintLabelBackgroundComponent> {
    return null;
  }

  getCardContentComponent(labelData: LabelData): Type<PrintLabelContentComponent> {
    return BrandInventoryLabelStackContentComponent;
  }
}
